<template>
    <div class="container py-2">
        <h4 class="mb-2">Measurements</h4>
        <div class="card">
            <div class="card-body">
                <vue-good-table
                        :columns="columns"
                        :isLoading.sync="isLoading"
                        :pagination-options="{enabled: true}"
                        :rows="rows"
                        :totalRows="totalRecords"
                        @on-column-filter="onColumnFilter"
                        @on-page-change="onPageChange"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        mode="remote"
                        styleClass="table table-hover">
                    <template slot="table-row" slot-scope="props">
                <span v-if="props.column.field == 'name'">
                    <router-link :to="{name: 'appUpdate', params: {id: props.row.id}}">{{props.row.name}}</router-link>
                </span>
                        <span v-else>
                  {{props.formattedRow[props.column.field]}}
                </span>
                    </template>
                </vue-good-table>
            </div>
        </div>
    </div>
</template>
<script>
    import 'vue-good-table/dist/vue-good-table.css'
    import {VueGoodTable} from 'vue-good-table';

    export default {
        name: 'userIndex',
        data() {
            return {
                isLoading: false,
                columns: [
                    {
                        label: 'Name',
                        field: 'name',
                    },
                    {
                        label: 'App id',
                        field: 'app_id',
                    },
                    {
                        label: 'Token',
                        field: 'token',
                    },
                    {
                        label: 'Order',
                        field: 'order',
                    },

                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    sort: {
                        field: '',
                        type: '',
                    },
                    page: 1,
                    perPage: 10
                }
            };
        },
        components: {
            VueGoodTable,
        },
        mounted() {
            this.getFromServer()
        },
        methods: {
            updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },

            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadItems();
            },

            onPerPageChange(params) {
                this.updateParams({perPage: params.currentPerPage});
                this.loadItems();
            },

            onSortChange(params) {
                this.updateParams({
                    sort: [{
                        type: params.sortType,
                        field: this.columns[params.columnIndex].field,
                    }],
                });
                this.loadItems();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                this.loadItems();
            },

            // load items is what brings back the rows from server
            loadItems() {
                this.getFromServer(this.serverParams).then(response => {
                    this.totalRecords = response.totalRecords;
                    this.rows = response.rows;
                });
            },
            async getFromServer() {
                let data = await this.$store.dispatch('GET_APPS')
                this.rows = data.data
            }
        }
    }
</script>
<style>
    .vgt-wrap__footer {
        color: #ffffff;
        padding: 0.5em!important;
        border: none!important;
        border-top: 1px solid #dcdfe6!important;
        background: #ffffff!important;
    }
</style>
